import { create } from 'zustand'
import { SERVER_URL } from '../constants'

const route = '/users';

export const useUserStore = create((set, get) => ({
  user: undefined,
  loading: false,
  setUser: (user) => set({ user }),
  setLoading: (loading) => set({ loading }),
  getUser: async (userid) => {
    set({ loading: true });
    const response = await fetch(`${SERVER_URL}${route}/${userid}`);
    const data = await response.json();
    set({ user: data });
    set({ loading: false });
  },

  updateUser: async (user) => {
    set({ loading: true });
    const response = await fetch(`${SERVER_URL}${route}/${user.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(user),
    });
    const data = await response.json();

    set({ loading: false });

    if (!response.ok) {
      throw new Error(data.message);
    }

    set({ user:data});
  },

   updateUserImage: async (id, file) => {
    set({ loading: true });
    const formData = new FormData();
    formData.append('avatar', file);
    formData.append('id', id);

    const response = await fetch(`${SERVER_URL}/users/${get().user.id}`, {
      method: 'PUT',
      body: formData,
    });
    const data = await response.json();

    set({ loading: false });

    if (!response.ok) {
      throw new Error(data.message);
    }

    set({ user:data});
  },
  
  verify: async (type, front, back) => {
    set({ loading: true });

    const formData = new FormData();
    formData.append('front', front);
    formData.append('back', back);
    formData.append('type', type);
    formData.append('id', get().user._id);

    const response = await fetch(`${SERVER_URL}/users/${get().user._id}/verify`, {
      method: 'PUT',
      body: formData,
    });
    const data = await response.json();

    set({ loading: false });

    if (!response.ok) {
      throw new Error(data.message);
    }

    set({ user:data});
  }
}))